export const metadataPrefix = "Shop used";
export const metadataPostfix  = " for sale on Carvana. Browse used cars online & have your next vehicle delivered to your door with as soon as next day delivery"